import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { DayforceBookingsProvider } from './context/DayforceBookingsProvider'
import { DayforceAgenciesProvider } from '../shared/context/DayforceAgenciesProvider'
import { DayforceBookingsMain } from './components/DayforceBookingsMain'

export const DayforceBookings = () => {
  return (
    <NuqsAdapter>
      <DayforceAgenciesProvider>
        <DayforceBookingsProvider>
          <DayforceBookingsMain />
        </DayforceBookingsProvider>
      </DayforceAgenciesProvider>
    </NuqsAdapter>
  )
}
